import {
  IItem,
  AbstractDrawableValuedItem,
  AbstractPlainTextItem,
  MovableTextBoxItem,
  TextBoxItem,
  IValueContainable,
  instanceOfIFontSizeAutoAdjustable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractItemValueAccessor } from "./AbstractValueAccessor";

export class NumberValueAccessor extends AbstractValueAccessor<string> {
  constructor(source: IItem) {
    super(NumberValueAccessor._createAccessor(source));
  }

  private static _createAccessor(source: IItem): IValueAccessible<string> {
    if (source instanceof TextBoxItem) {
      return new TextBoxItemFreeNumberAccessor(source);
    } else if (source instanceof MovableTextBoxItem) {
      return new MovableTextBoxItemFreeNumberAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractNumberValueAccessor<T extends IItem & IValueContainable> extends AbstractItemValueAccessor<T, string> {
  constructor(source: T) {
    super(source);
  }

  protected _set(source: T, value: string): void {
    this.__set(source, value);
    if (source instanceof AbstractDrawableValuedItem) { // TODO: リファクタ.適切なinterfaceを定義すべき.
      source.adjustObjectHeight();
    }
    if (instanceOfIFontSizeAutoAdjustable(source)) {
      source.adjustFontSize();
    }
  }

  protected abstract __set(source: T, value: string): void;
}

abstract class AbstractTextBoxItemFreeNumberAccessor<T extends AbstractPlainTextItem> extends AbstractNumberValueAccessor<T> {
  constructor(source: T) {
    super(source);
  }

  protected _validate(source: T): void {
    if (!source.isFreeInputable || !source.shouldInputFree) {
      throw new Error("非フリー入力");
    }
  }

  protected _get(source: T): string {
    return source.value;
  }

  protected __set(source: T, value: string): void {
    source.value = value;
  }
}

class TextBoxItemFreeNumberAccessor extends AbstractTextBoxItemFreeNumberAccessor<TextBoxItem> {
  constructor(source: TextBoxItem) {
    super(source);
  }
}

class MovableTextBoxItemFreeNumberAccessor extends AbstractTextBoxItemFreeNumberAccessor<MovableTextBoxItem> {
  constructor(source: MovableTextBoxItem) {
    super(source);
  }
}
